import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { LoginModule } from './login/login.module';
import { LoginInComponent } from './login/login-in.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AuthGuard } from './auth/auth.guard';
import { UserServiceService } from './services/user-service.service';
import { LoginService } from './services/login.service';
import { NgxEditorModule } from 'ngx-editor';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { NgxBarcodeModule } from 'ngx-barcode';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ExcelService } from 'src/ExportExcel/excel.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LightboxModule } from '@ngx-gallery/lightbox';
import { GalleryModule } from '@ngx-gallery/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

export function translateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({

  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateHttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserModule,
    LoginModule,
    LayoutModule,
    NgxEditorModule,
    HttpClientModule,
    NgbModule,
    NgxBarcodeModule,
    NgxSpinnerModule,
    ToastrModule.forRoot(),
    RouterModule.forRoot([
      { path: '**', component: LoginInComponent }
    ]),
    BrowserAnimationsModule,
    MaterialModule,
    GalleryModule,
    LightboxModule
  ],

  declarations: [
    AppComponent

  ],
  providers: [ExcelService, AuthGuard, UserServiceService, LoginService, ToastrService],
  bootstrap: [AppComponent],
  entryComponents: []
})
export class AppModule {


}
